import { useEffect, useState } from "react";
import { Plus, Trash2, Save, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageHeader, Btn, Field, Area } from "@/components/admin/ui";

export default function TestimonialsAdmin() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/testimonials").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => { await api.post("/admin/testimonials", { author: "New Client", quote: "", order: items.length }); toast.success("Added"); load(); };
  const save = async (t) => { await api.put(`/admin/testimonials/${t.id}`, t); toast.success("Saved"); load(); };
  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/testimonials/${id}`); toast.success("Deleted"); load(); };
  const upd = (id, patch) => setItems(items.map((t) => t.id === id ? { ...t, ...patch } : t));

  return (
    <div data-testid="admin-testimonials">
      <PageHeader title="Testimonials" subtitle="Client stories shown on the homepage and testimonials page">
        <Btn onClick={add}><Plus size={16} /> Add Testimonial</Btn>
      </PageHeader>
      <div className="space-y-4">
        {items.map((t) => (
          <div key={t.id} className="bg-white rounded-2xl border border-stone-200/80 p-6 space-y-3">
            <div className="flex items-center justify-between">
              <Field label="Author" value={t.author} onChange={(v) => upd(t.id, { author: v })} />
              <div className="flex gap-1 pt-5">
                <button onClick={() => upd(t.id, { visible: !t.visible })} className="p-2 rounded-lg hover:bg-stone-100 text-stone-500">{t.visible ? <Eye size={16} /> : <EyeOff size={16} />}</button>
                <button onClick={() => del(t.id)} className="p-2 rounded-lg hover:bg-red-50 text-red-500"><Trash2 size={16} /></button>
              </div>
            </div>
            <Area label="Quote" value={t.quote} onChange={(v) => upd(t.id, { quote: v })} rows={3} />
            <div className="flex justify-end"><Btn onClick={() => save(t)}><Save size={16} /> Save</Btn></div>
          </div>
        ))}
      </div>
    </div>
  );
}
